import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';
import styled from 'styled-components';

const SpinnerWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
`;

const Spinner = () => {
  const antIcon = <LoadingOutlined style={{ fontSize: '80px', color: '#397CF3' }} spin />;
  return (
    <SpinnerWrap>
      <Spin indicator={antIcon} style={{ margin: 'auto' }} />
    </SpinnerWrap>
  );
};

export default Spinner;
